import { DirectionsBoat, People, PieChart, ViewModule } from '@mui/icons-material';

export const menuObject = [
    {
        "menuLabel": "Dashboard",
        "menuDisplay": "Dashboard",
        "menuIcon": <PieChart />,
        "tableName": "DashBoard",
        "menuUrl": "dashboard"
    },
    {
        "menuLabel": "Accounting",
        "menuIcon": <People />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "UserConfig",
                "subMenuDisplay": "UserConfig",
                "subMenuOpen": false,
                "tableName": "user config",
                "subMenuUrl": "go/UserConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "RoleConfig",
                "subMenuDisplay": "RoleConfig",
                "subMenuOpen": false,
                "tableName": "role config",
                "subMenuUrl": "go/RoleConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "UsersGroups",
                "subMenuDisplay": "UsersGroups",
                "subMenuOpen": false,
                "tableName": "usersGroups",
                "subMenuUrl": "go/usersGroupsList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Company",
                "subMenuDisplay": "Company",
                "subMenuOpen": false,
                "tableName": "company",
                "subMenuUrl": "master/company",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Entities",
                "subMenuDisplay": "Entities",
                "subMenuOpen": false,
                "tableName": "Account",
                "subMenuUrl": "go/entities",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "LumpSum",
                "subMenuDisplay": "LumpSum",
                "subMenuOpen": false,
                "tableName": "LumpSum",
                "subMenuUrl": "master/lumpSumList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Quotes",
                "subMenuDisplay": "Quotes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/quoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ChargeRules",
                "subMenuDisplay": "ChargeRules",
                "subMenuOpen": false,
                "tableName": "ChargeRule",
                "subMenuUrl": "go/chargeRules",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Shipping",
        "menuIcon": <DirectionsBoat />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Vessel",
                "subMenuDisplay": "Vessel",
                "subMenuOpen": false,
                "tableName": "Vessel",
                "subMenuUrl": "master/vessel",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Voyages",
                "subMenuDisplay": "Voyages",
                "subMenuOpen": false,
                "tableName": "Voyages",
                "subMenuUrl": "go/voyages",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Bookings",
                "subMenuDisplay": "Bookings",
                "subMenuOpen": false,
                "tableName": "Bookings",
                "subMenuUrl": "go/Bookings",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBooking",
                "subMenuDisplay": "ApproveBooking",
                "subMenuOpen": false,
                "tableName": "Approve Booking",
                "subMenuUrl": "go/approveBookingList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "BL's",
                "subMenuDisplay": "BL's",
                "subMenuOpen": false,
                "tableName": "BLs",
                "subMenuUrl": "go/BLs",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBL",
                "subMenuDisplay": "ApproveBL",
                "subMenuOpen": false,
                "tableName": "Approve BL",
                "subMenuUrl": "go/approveBLList",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "GenericEntity",
        "menuDisplay": "Generic Entity",
        "menuIcon": <ViewModule />,
        "tableName": "GENERICENTITY",
        "menuUrl": "",  // Vazio porque vai ter submenus
        "subMenus": []  // Será preenchido dinamicamente
    },
    {
        "menuLabel": "ExtensionDemo",
        "menuDisplay": "Extension Demo",
        "tableName": "EXTENSION_DEMO",
        "menuUrl": "extension-demo"
    }
]